import React from 'react';
import {DEFAULT} from "../../../constants/design/SkinTypes"
import {addPrefix} from "../../../utils/UriUtil"

function SetButton({skinName, onSet}) {
  return (
    <button className="btn_post" onClick={() => onSet(skinName)}>적용</button>
  )
}

function DefaultSkinActions({skin, selected, onSet}) {
  function handlePreview(skinName) {
    window.open(addPrefix(`/manage/previewSkin.php?skin=${skinName}&mark=true`, '_blank'));
  }

  return (
    <div className="deco_skin">
      <a href="#" className="btn_post" onClick={() => handlePreview(skin.skinName)}>
        미리보기 <span className="ico_blog ico_blank" />
      </a>
      {!selected &&
        <SetButton skinName={skin.skinName} onSet={onSet}/>
      }
    </div>
  )
}

function ArchiveSkinActions({skin, onSet, onDelete}) {
  function handleDownload(skin) {
    window.location = addPrefix(`/manage/design/skin/download.zip?folderName=${skin.folderName}&isArchiveSkin=true`);
  }

  return (
    <div className="deco_skin">
      <SetButton skinName={`customize/${skin.folderName}`} onSet={onSet} />
      <a href="#" className="btn_post" onClick={() => handleDownload(skin)}>다운로드</a>
      <button className="btn_post" onClick={() => onDelete(skin.folderName)}>삭제</button>
    </div>
  )
}


export default function SkinCardActions({skin, type, selected, onSet, onDelete}) {
  if (type === DEFAULT) {
    return <DefaultSkinActions skin={skin} selected={selected} onSet={onSet} />
  } else {
    return <ArchiveSkinActions skin={skin} onSet={onSet} onDelete={onDelete} />
  }
}
